import { ESelectIntents } from '@src/typings';
import { cva } from 'class-variance-authority';

export const selectVariants = cva(
    'w-full min-w-40 !text-base !font-normal rounded-lg !shadow-none disabled:opacity-60 transition-all',
    {
        variants: {
            intent: {
                [ESelectIntents.default]: '',
                [ESelectIntents.filled]: '',
                [ESelectIntents.light]: '',
            },
            size: {
                sm: 'h-10 text-sm',
                md: 'h-10 text-base',
                lg: 'h-10 text-lg',
            },
            bordered: {
                true: '',
                false: 'border-none',
            },
            error: {
                true: '',
                false: '',
            },
        },
        defaultVariants: {
            intent: ESelectIntents.default,
            size: 'md',
            bordered: true,
        },
    }
);
